module.exports = __webpack_public_path__ + "img/24-5.47b58f51.jpg";